<template>
  <div id="app">
    <nav class="row">
      <div class="menu-content-item menu-content-item-f">
        <div class="menu-content-item-word">F<div class="disappearing-chars">orty</div>
        </div>
      </div>

      <div class="menu-content-item menu-content-item-o">
        <div class="menu-content-item-word">O<div class="disappearing-chars">ne</div></div>
      </div>
      <div class="menu-content-item menu-content-item-r">
        <div class="menu-content-item-word">R<div class="disappearing-chars">avens</div>
        </div>
      </div>

      <div class="menu-content-item menu-content-item-star">
        <div class="menu-content-item-word">*</div>
      </div>
    </nav>

    <div class="row main-row">
      <main class="main">
        <div class="main-content">
          <div class="main-content-line-1">
            The investments and interests of David B. Heller
          </div>
          <div class="main-content-line-2">Launching Winter 2020</div>

          <div class="content-footer">
            <span class="footer-start">40</span>
            <span class="footer-bar"></span>
            <span class="footer-end">42</span>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import SplitText from "./lib/gsap/bonus-files-for-npm-users/SplitText";
import {
  TweenMax,
  TimelineMax,
  CSSPlugin,
  ScrollToPlugin,
  Power2
} from "gsap/all";
const plugins = [CSSPlugin];

function getOffset(stagger, maxLen, len) {
  return (maxLen - len) * stagger;
}

export default {
  name: "App",
  components: {},
  props: {
    backgroundUrl: String,
    hoveredTo: String,
    companies: Array
  },
  methods: {},
  mounted: function() {
    let forty = new SplitText(".menu-content-item-f .disappearing-chars", {
      type: "chars"
    });
    let one = new SplitText(".menu-content-item-o .disappearing-chars", {
      type: "chars"
    });
    let ravens = new SplitText(".menu-content-item-r .disappearing-chars", {
      type: "chars"
    });

    let stagger = 0.2;
    let maxLen = ravens.chars.length;

    let scaleDuration = 0.2;
    let alphaDuration = .8;
    let tl = new TimelineMax();
    tl.addLabel("revealF", "+=.5");
    // tl.add(
    //   TweenMax.to(".menu-content-item-f", scaleDuration, { scaleY: 1 }),
    //   "revealF"
    // );
    tl.add(
      TweenMax.to(".menu-content-item-f", alphaDuration, { autoAlpha: 1 }),
      "revealF"
    );

    tl.addLabel("revealO");
    // tl.add(
    //   TweenMax.to(".menu-content-item-o", scaleDuration, { scaleX: 1 }),
    //   "revealO"
    // );
    tl.add(
      TweenMax.to(".menu-content-item-o", alphaDuration, { autoAlpha: 1 }),
      "revealO"
    );

    tl.addLabel("revealR");
    // tl.add(
    //   TweenMax.to(".menu-content-item-r", scaleDuration, { scaleY: 1 }),
    //   "revealR"
    // );
    tl.add(
      TweenMax.to(".menu-content-item-r", alphaDuration, { autoAlpha: 1 }),
      "revealR"
    );

    tl.add(
      TweenMax.to(".menu-content-item-star", scaleDuration, {
        autoAlpha: 1,
        // scaleY: 1
      })
    );

    // tl.addLabel("start", "+=.25");
    // tl.add(
    //   TweenMax.staggerTo(forty.chars.reverse(), 0.1, { autoAlpha: 0 }, stagger),
    //   "start+=" + getOffset(stagger, maxLen, forty.chars.length)
    // );
    // tl.add(
    //   TweenMax.staggerTo(one.chars.reverse(), 0.1, { autoAlpha: 0 }, stagger),
    //   "start+=" + getOffset(stagger, maxLen, one.chars.length)
    // );
    // tl.add(
    //   TweenMax.staggerTo(
    //     ravens.chars.reverse(),
    //     0.1,
    //     { autoAlpha: 0 },
    //     stagger
    //   ),
    //   "start+=" + getOffset(stagger, maxLen, ravens.chars.length)
    // );
    // tl.add(
    //   TweenMax.to(".menu-content-item-f .disappearing-chars", 2, { clip: "rect(0px, 0px, 0px, 0px)" }),
    //   "start+=" + getOffset(stagger, maxLen, forty.chars.length)
    // );
    
    

    tl.addLabel("showline1", "+=.75");
    tl.add(TweenMax.from(".main-content-line-1", 0.75, { y: 20 }), "showline1");
    tl.add(
      TweenMax.to(".main-content-line-1", 0.75, { autoAlpha: 1 }),
      "showline1"
    );
    tl.addLabel("showline2", "+=.75");
    tl.add(TweenMax.from(".main-content-line-2", 0.75, { y: 20 }), "showline2");
    tl.add(
      TweenMax.to(".main-content-line-2", 0.75, { autoAlpha: 1 }),
      "showline2"
    );

    tl.addLabel("showline3", "+=.75");
    tl.add(TweenMax.from(".content-footer", 0.75, { y: 20 }), "showline3");
    tl.add(TweenMax.to(".content-footer", 0.75, { autoAlpha: 1 }), "showline3");

    tl.addLabel("disappearChars", "+=5");
    tl.call(function(){
      document.querySelectorAll('.disappearing-chars').forEach(function(e){
        e.classList.add('hidden');
      });
    });
  }
};
</script>

<style scoped lang="scss">
@import "styles/_variables.scss";

.main {
  padding: 6rem 8rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  box-sizing: border-box;
  text-align: center;
  width: 100vw;
}

.main-content {
}

.main-content-line-1 {
}
.main-content-line-2 {
  font-family: $font-national;
  font-size: 14px;
  text-transform: uppercase;
  margin-top: 5px;
}

#app {
  font-family: "Noe Display", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  font-size: 2.7rem;
}

.menu-content-item {
  position: fixed;
  font-size: 6rem;
  // transition: all 0.2s ease;
  text-decoration: none;
  color: $color-primary;
  font-weight: bold;
  padding: 6rem;
  opacity: 0;
  // transform: scaleY(0);
}

.menu-content-item-f {
  left: 0;
  top: 0;
}
.menu-content-item-o {
  right: 0;
  top: 0;
  // transform: scaleY(1) scaleX(0);
}
.menu-content-item-r {
  right: 0;
  bottom: 0;
}
.menu-content-item-star {
  left: 0;
  bottom: 0;
}
.menu-content-item-o .menu-content-item-word {
  transform: rotate(90deg) translate3d(0.3em, -0.4em, 0);
}
.menu-content-item-star .menu-content-item-word,
.menu-content-item-r .menu-content-item-word {
  transform: rotate(180deg);
}
.disappearing-chars {
  display: inline-block;

  transition: clip-path 1.25s ease-out, opacity .6s ease;
  clip-path: inset(0 0 0 0);
  opacity: 1;
}
.disappearing-chars.hidden {
  clip-path: inset(0 100% 0 0);
  // opacity: 0;
}

.main-content-line-1,
.main-content-line-2 {
  opacity: 0;
}

.content-footer {
  font-size: 1.3rem;
  text-align: center;
  font-family: $font-national;
  position: fixed;
  bottom: 9rem;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
}
.footer-bar {
  display: inline-block;
  border-bottom: 1px solid;
  border-bottom-color: inherit;
  width: 10em;
  position: relative;
  top: -0.2em;
  margin-right: 0.15em;

  @media screen and (max-width: 780px) {
    width: 5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue